module.exports = __webpack_public_path__ + "static/media/water.1855351f.webp";